import React from "react";
import Container from "../../elements/Container";
import Plate from "../../../assets/img/Background/Assiette-burger-frites.png";
import Burger from "../../../assets/img/Background/Burger.png";
import Salsa from "../../../assets/img/Background/Sauce-pimente.png";
import Heading from "../../elements/displayTitles/Heading";

export default function Booking() {
   return (
      <Container>
         <div className="w-full h-full mb-20 relative">
            <img
               className="hidden xl:block absolute -top-20 -left-36 "
               src={Burger}
               alt="Burger vue du dessus"
            />
            <img
               className="hidden xl:block absolute top-40 left-5"
               src={Salsa}
               alt="Bouteille de sauce piquante"
            />
            <img
               className="hidden xl:block absolute top-12 -right-96"
               src={Plate}
               alt="Assiette vue du dessus, comportant un burger et des frites"
            />
            <div className="max-w-3xl m-auto h-full md:py-12">
               <Heading
                  variant="h4"
                  theme="secondary"
                  position="center"
                  className="mb-3"
               >
                  Réservation
               </Heading>
               <Heading
                  theme="title"
                  variant="h3"
                  position="center"
                  className="mb-5"
               >
                  Réservez votre table
               </Heading>
               <form className="grid grid-cols-2 gap-x-7 gap-y-6 md:mt-14 font-secondary">
                  <div className="">
                     <label htmlFor="name">Nom</label>
                     <input
                        className="rounded-md py-3 uppercase focus:ring-primary focus:border-primary block w-full border-gray-300"
                        type="text"
                        name="name"
                        id="name"
                        placeholder="John Doe"
                        required
                     />
                  </div>
                  <div className="">
                     <label htmlFor="email">Email</label>
                     <input
                        className="rounded-md py-3 uppercase focus:ring-primary focus:border-primary block w-full border-gray-300"
                        type="email"
                        name="email"
                        id="email"
                        placeholder="votre@mail.fr"
                     />
                  </div>
                  <div className="">
                     <label htmlFor="date">Date</label>
                     <input
                        className="rounded-md py-3 uppercase focus:ring-primary focus:border-primary block w-full border-gray-300"
                        type="date"
                        name="date"
                        id="date"
                        required
                     />
                  </div>
                  <div className="">
                     <label htmlFor="time">Heure</label>
                     <input
                        className="rounded-md py-3 uppercase focus:ring-primary focus:border-primary block w-full border-gray-300"
                        type="time"
                        name="time"
                        id="time"
                        required
                     />
                  </div>
                  <div className="">
                     <label htmlFor="customers">Nombre de personnes</label>
                     <input
                        className="rounded-md py-3 uppercase focus:ring-primary focus:border-primary block w-full border-gray-300"
                        type="text"
                        name="customers"
                        id="customers"
                        placeholder="5"
                        required
                     />
                  </div>
                  <div className="">
                     <label htmlFor="send" className="invisible">
                        Réserver
                     </label>
                     <input
                        className="rounded-md py-3 uppercase bg-primary hover:bg-primary-hover tracking-widest w-full cursor-pointer shadow-sm animated"
                        type="submit"
                        name="send"
                        id="send"
                        value="Réserver"
                        required
                     />
                  </div>
               </form>
            </div>
         </div>
      </Container>
   );
}

